import type { Kurs } from "./general";

export const KursyRachunkowoscList: Array<Kurs> = [
	{
		slug: "rach_teoria_podst",
		title: "Rachunkowość - Teoria",
		description: "Kurs teoretyczny, który krok po kroku wprowadza w świat rachunkowości. Poznasz fundamenty systemu rachunkowości, zasady prowadzenia ewidencji i wiele innych.",
		level: "podstawa",
		category: "rachunkowosc",
		productId: null,
	},
	{
		slug: "rach_praktyka_podst",
		title: "Rachunkowość - Praktyka",
		description: "Praktyczny moduł skupiony na nauce obsługi programów księgowych i zastosowaniu teorii w codziennej pracy.",
		level: "podstawa",
		category: "rachunkowosc",
		productId: null,
	},
	{
		slug: "rach_combo_podst",
		title: "Rachunkowość - Combo",
		description: "Kompleksowy pakiet łączący teorię i praktykę rachunkowości. Najpierw zdobędziesz solidne podstawy teoretyczne, a następnie przećwiczysz je w praktyce",
		level: "podstawa",
		category: "rachunkowosc",
		productId: null,
	},
	// {
	// 	slug: "rach_teoria_rozsz",
	// 	title: "Rachunkowość - Teoria Zaawansowane",
	// 	description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia.",
	// 	level: "rozszerzenie",
	// },
	// {
	// 	slug: "rach_praktyka_rozsz",
	// 	title: "Rachunkowość - Praktyka Zaawansowane",
	// 	description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.",
	// 	level: "rozszerzenie",
	// },
	// {
	// 	slug: "rach_combo_rozsz",
	// 	title: "Rachunkowość - Combo Zaawansowane",
	// 	description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis.",
	// 	level: "rozszerzenie",
	// },
];